module.exports = __webpack_public_path__ + "img/strength2x.30bf2b75.png";